import Vue from 'vue'
import App from './components/App.vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

var router = new VueRouter({
  mode: 'history',
  routes: []
})

new Vue({
  el: '#member-signup-help-banner',
  router,
  render (createElement) {
    return createElement(App)
  }
})
